import { initContract } from "@ts-rest/core";
import { z } from "zod";

const c = initContract();

const partRequestSchema = z.object({
  quantity: z.number().int().positive().nullish(),
  material: z.string().nullish(),
  description: z.string().nullish(),
  urgency: z.enum(["low", "medium", "high", "urgent"]).nullish(),
  deadline: z.string().nullish(),
  finish: z.string().nullish(),
  tolerance: z.string().nullish(),
  dimensions: z.string().nullish(),
});

const emailExtractionSchema = z.object({
  parts: z.array(partRequestSchema),
  customerNotes: z.string().nullish(),
  isQuoteRequest: z.boolean(),
  confidence: z.number().min(0).max(1),
  language: z.string().nullish(),
});

export const notificationsContract = c.router({
  testOutlookConnection: {
    method: "POST",
    path: "/notifications/outlook/test",
    body: z.object({
      type: z.enum(["connection", "send"]),
    }),
    responses: {
      200: z.object({
        success: z.boolean(),
        message: z.string().optional(),
      }),
    },
  },
  analyzeEmailContent: {
    method: "POST",
    path: "/notifications/analyze-email",
    body: z.object({
      emailContent: z.string(),
    }),
    responses: {
      200: z.object({
        success: z.boolean(),
        analysis: emailExtractionSchema.nullish(),
        summary: z.string().nullish(),
        error: z.string().optional(),
      }),
    },
  },
  onboardingUpload: {
    method: "POST",
    path: "/notifications/onboarding-upload",
    body: z.object({
      email: z.string().optional(),
      companyId: z.string().optional(),
      s3Folder: z.string(),
    }),
    responses: {
      200: z.object({
        success: z.boolean(),
        message: z.string().optional(),
      }),
    },
  },
  onboardingUploadError: {
    method: "POST",
    path: "/notifications/onboarding-upload-error",
    body: z.object({
      email: z.string().optional(),
      companyId: z.string().optional(),
      error: z.string(),
    }),
    responses: {
      200: z.object({
        success: z.boolean(),
        message: z.string().optional(),
      }),
    },
  },
  userFeedback: {
    method: "POST",
    path: "/notifications/user-feedback",
    body: z.object({
      email: z.string(),
      message: z.string().default("No message"),
      url: z.string(),
      posthogSessionUrl: z.string().optional(),
      companyId: z.string(),
      companyName: z.string(),
      modelName: z.string(),
      modelId: z.string(),
      modelKey: z.string(),
    }),
    responses: {
      200: z.object({
        success: z.boolean(),
      }),
    },
  },
});
